module.exports = __webpack_public_path__ + "img/alan-pro.0bb8a105.jpg";